module.exports = "<nav aria-label=\"page navigation\" *ngIf=\"range\" class=\"float-lg-right float-md-right float-xs-right mr-1\">\n  <ul class=\"pagination\">\n    <li class=\"page-item\" *ngFor=\"let i of range\" [ngClass]=\"{ active: i == currentPage }\">\n      <a href=\"#\" (click)=\"pageLinkClick($event, i)\" class=\"page-link\" *ngIf=\"i != '...'\">{{ i }}</a>\n      <span class=\"page-link\" *ngIf=\"i == '...'\">{{ i }}</span>\n    </li>\n  </ul>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/pagination/pagination.component.html
// module id = ./src/app/common/pagination/pagination.component.html
// module chunks = main